import Dashboard from "../../views/dashboard/Dashboard.vue";

const abnormaldetails = {
  path: "/abnormaldetails",
  name: "abnormaldetails",
  redirect: "accessanomaly",
  component: Dashboard,
  children: [
    {
      path: "/accessanomaly",
      name: "accessanomaly",
      component: () =>
        import("../../components/abnormaldetails/accessanomaly.vue"),
      meta: {
        title: "门禁异常",
        icon: "el-icon-warning",
        role: false
      }
    }
  ]
};

export default abnormaldetails;
